module.exports = __webpack_public_path__ + "static/media/Avatar6.9a772005.svg";